import api from '@/lib/api';
import type {
  AdminTicketListResponse,
  AdminTicketDetail,
  TicketStatus,
  TicketPriority,
  TicketCategory,
} from '@/types/admin';

export interface TicketsQuery {
  status?: TicketStatus | '';
  priority?: TicketPriority | '';
  category?: TicketCategory | '';
  assignedTo?: string;
  q?: string;
  page?: number;
  perPage?: number;
}

function unwrap<T>(data: T | { data: T }): T {
  return (data as { data?: T }).data ?? (data as T);
}

export async function fetchTickets(params: TicketsQuery): Promise<AdminTicketListResponse> {
  const { data } = await api.get('/admin/tickets', { params });
  return unwrap<AdminTicketListResponse>(data);
}

export async function fetchTicket(id: string): Promise<AdminTicketDetail> {
  const { data } = await api.get(`/admin/tickets/${id}`);
  return unwrap<AdminTicketDetail>(data);
}

export interface PostMessagePayload {
  body: string;
  attachments?: Array<{ name: string; url: string }>;
}

export async function postTicketMessage(id: string, payload: PostMessagePayload): Promise<void> {
  await api.post(`/admin/tickets/${id}/messages`, payload);
}

export interface PatchTicketPayload {
  status?: TicketStatus;
  priority?: TicketPriority;
  assignedTo?: string | null;
}

export async function patchTicket(id: string, payload: PatchTicketPayload): Promise<void> {
  await api.patch(`/admin/tickets/${id}`, payload);
}
